import styled from 'styled-components';
import MarketoForm from '../MarketoForm';

export const StyledForm = styled(MarketoForm)`
  .signup-form--title {
    display: none;
  }

  .ant-form-item-control {
    line-height: 32px;
    @media (max-width: 768px) {
      padding-left: 0px;
    }
  }
  .data-layer-form {
    display: flex !important;
    justify-content: flex-end;
  }
  .signup-form--form .ant-form-item {
    margin: 0px;
  }
  .signup-form--form .ant-form-item button {
    margin: 0 !important;
    font-size: 18px;
    font-weight: bold;
    height: 55px;
    line-height: 1.5;
    width: max-content;

    span.anticon-download {
      margin-right: 5px;
    }

    @media (max-width: 768px) {
      width: 100%;
      padding: 12px 24px;
    }
  }
  .text-field-wrapper .text-field-input {
    width: 290px;
    height: 55px !important;
    padding: 24px 24px;
    font-size: 18px !important;
    margin-right: 16px;
    @media (max-width: 768px) {
      width: 100%;
      padding: 12px 24px;
      margin-right: 0px;
    }
  }
  .section-hero--notification {
    text-align: center;
  }
  @media (max-width: 768px) {
    .data-layer-form {
      flex-direction: column;
    }

    .ant-row.ant-form-item {
      width: 100%;
      margin-bottom: 12px;

      &:first-child {
        max-width: 100%;
      }
    }
  }
`;

export const SubscribeLabel = styled.div`
  font-size: 16px;
  padding-top: 10px;
  @media (max-width: 768px) {
    padding-left: 0px;
    font-size: 17px;
  }
`;
